// extracted by mini-css-extract-plugin
export default {"cta":"OrderDetailsTrigger_cta__hL6MI"};